import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import logo from '../../../assets/images/bonusly-logo.png';
import { useSeasonalLogo } from '../../../components/seasonal/use-seasonal-logo';

export const CompanyLogo: FC = () => {
	const company = useCurrentCompany();
	const { t } = useTranslation('navigation');
	const { logoUrl: seasonalLogo } = useSeasonalLogo();

	// Determine which logo to use: seasonal > company > default
	const logoConfig = useMemo(() => {
		const logoSrc = seasonalLogo || company?.logo_url || logo;
		const logoAlt = seasonalLogo
			? t('links.company_logo', { name: 'Bonusly 🎃' })
			: company?.logo_url
				? t('links.company_logo', { name: company.name })
				: t('links.company_logo', { name: 'Bonusly' });

		return { logoSrc, logoAlt };
	}, [seasonalLogo, company?.logo_url, company?.name, t]);

	return <Image alt={logoConfig.logoAlt} h="full" objectFit="contain" src={logoConfig.logoSrc} />;
};
